import { AppName } from 'src/global/globalConfig';
import analyticsTracking from 'src/services/analytics-service';

const usePortfolioSpeciesRiskAnalytics = () => {
    const sendTrackEvent = (ga: { action: string; category?: string; label?: string }) => {
        analyticsTracking.trackEvent({
            ...ga,
            project: 'Portfolio',
            category: 'Portfolio Species Risk',
            app: AppName.PORTFOLIO_SPECIES_RISK,
        });
    };

    const trackFrameworkClick = () => {
        sendTrackEvent({
            action: `portfolio_species_risk_framework_click`,
        });
    };

    const trackTabClick = (params: { tab: string }) => {
        sendTrackEvent({
            action: `portfolio_species_risk_${params.tab}_tab_click`,
        });
    };

    const trackSitesLinkClick = (params: { tab: string }) => {
        sendTrackEvent({
            action: `portfolio_species_risk_${params.tab}_sites_link_click`,
        });
    };

    const trackSpeciesRiskModalOpen = (params: { tab: string }) => {
        sendTrackEvent({
            action: `portfolio_species_risk_${params.tab}_modal_open`,
        });
    };

    return {
        sendTrackEvent,
        trackFrameworkClick,
        trackTabClick,
        trackSitesLinkClick,
        trackSpeciesRiskModalOpen,
    };
};

export default usePortfolioSpeciesRiskAnalytics;
